import { FormattedMessage } from 'react-intl'
import React from 'react'

export const renderTableCell = (path: string, str?: string) => (
	!!str && str.length ?
		<FormattedMessage
			id={`${path}.${str}`}
			defaultMessage="Table Cell"
			description="Table Cell"
		/>
		:
		<></>
)